import Vue from 'vue';
import axios from 'axios';

const state = {
    disciplines: [],
    tags: [],
    offerList: [],
    projectDetails: {},
    featureFlags: {},
    currencyList: [],
}

const mutations = {
    SET_DESCIPLINES (state, disciplines) {
        Vue.set(state, 'disciplines', disciplines);
    },
    SET_TAGS (state, tags) {
        Vue.set(state, 'tags', tags);
    },
    SET_OFFER_LSIT(state, offerList) {
        Vue.set(state, 'offerList', offerList);
    },
    SET_PROJECT_DETAILS (state, projectDetails) {
        state.projectDetails = projectDetails
    },
    SET_FEATURE_FLAGS(state, payload) {
        state.featureFlags = payload
    },
    SET_CURRENCY_LIST(state, payload) {
        Vue.set(state, 'currencyList', payload);
    }
}

const actions = {
    getProjectList({commit}) {
        return axios.get(`${process.env.VUE_APP_API}/project/list`);
    },
    getFeatureAuthToken({commit}) {
        axios({
            url: process.env.VUE_APP_API + '/flags',
            method: 'get'
        }).then((res) => {
            console.log('flags => ',res.data.data);
            commit('SET_FEATURE_FLAGS', res.data.data)
        })
    },
    async setDisciplines ({commit}, disciplineList) {
        commit('SET_DESCIPLINES', disciplineList);
    },
    async setTagList({commit}, mrId) {
        const tagList = await axios.get(`${process.env.VUE_APP_API}/mr/taglist?mr_id=${mrId}`);
        console.log('set tag list', tagList);
        commit('SET_TAGS', tagList.data.tags);
    },
    getVendorTimeline({commit}, param) {
        return axios.post(`${process.env.VUE_APP_API}/offer/vendor_timeline`, param);
    },
    getUnitsList() {
        return axios.get(`${process.env.VUE_APP_API}/tagged/units`);
    },
    // F2: currency master list. GET {{API}}/tbe/currency — returns the master list.
    // EPC/PRC call it bare; the vendor context passes { token, vendor_id } as query params
    // (needed for the price-header currency hover on the vendor screen).
    async getCurrencyList({ state, commit }, params) {
        if (state.currencyList && state.currencyList.length) {
            return state.currencyList;
        }
        const res = await axios.get(`${process.env.VUE_APP_BIDEVAL}/tbe/currency`, params ? { params } : undefined);
        // Must end up an array. The previous `res?.data?.data || res?.data || []` chain committed the
        // whole { status, data, message } envelope whenever data was null/empty — the envelope is
        // truthy, so consumers' own `|| []` guards never fired and currencyList.find(...) threw
        // inside a render-path computed, blanking the SOS/MTO grid.
        const raw = res?.data?.data ?? res?.data;
        const list = Array.isArray(raw) ? raw : [];
        commit('SET_CURRENCY_LIST', list);
        return list;
    },
    // F2: PRC sets the bid currency. POST {{API}}/tbe/currency with { mr_id, currency, category }.
    // Vendor never sets currency — they enter prices in whatever currency PRC chose.
    saveTbeCurrency({ commit }, params) {
        return axios.post(`${process.env.VUE_APP_BIDEVAL}/tbe/currency`, params);
    },
    // F2 SG5-US2 / SG2-US2: register a vendor "push OLD price -> BAFO Unit Price" intent for a line item.
    // Per F2 API contract #16: FE additionally calls the existing per-category write endpoint to persist the value.
    pushBafoLineItem({ commit }, params) {
        return axios.post(`${process.env.VUE_APP_API}/bafo/push/lineitems`, params);
    },
    // F2 SG5-US3 / SG2-US3: ask BE to inject the BAFO system commercial fields (or a custom field) onto the offer.
    // Per F2 API contract #15: type "system" adds discount%, discount_amt, tax_type, tax_rate (and Comment when BE includes it).
    addBafoFields({ commit }, params) {
        return axios.post(`${process.env.VUE_APP_API}/bafo/add/fields`, params);
    },
    // F2 SG5-US4 / SG2-US4 (EQ-4): the ONLY write path for offer-level Grand Total summary state.
    // BE split GET/POST on /grand_total (app.py, class GrandTotal): the GET used to call update_one
    // unconditionally, so every read silently mutated grand_total / grand_total_before_discount /
    // summary_discount_amount. POST is now the only mutating verb; GET is read-only.
    //
    // JSON BODY (offer_id travels in the body here, NOT as a query param):
    //   { offer_id, summary_discount_percent?, summary_discount_amount?, summary_remarks? }
    //   summary_discount_amount may be sent instead of / alongside the percent to override the
    //   computed amount. Vendor auth (vendor_id + token) may ride in the body or the query string;
    //   we keep it in the body so there is a single payload.
    // Returns the same envelope + shape as the single-offer GET, so callers can apply the response
    // to their local Grand Total state either way.
    // 400s to expect: "Summary discount is not yet enabled for this offer." and "No fields to update."
    saveGrandTotalSummary({ commit }, params) {
        return axios.post(`${process.env.VUE_APP_BIDEVAL}/grand_total`, params);
    },
    // F2 SG5-US5 / SG2-US5: read the BE-computed Grand Total + summary-discount state. READ-ONLY as
    // of the BE GET/POST split — it no longer persists anything, so discount/remark fields must go
    // to saveGrandTotalSummary above rather than riding along here.
    // GET ?offer_id= → { grand_total, grand_total_before_discount, summary_discount_enabled,
    //                    summary_discount_percent, summary_discount_amount, summary_remarks }
    // Repeated ?offer_id=A&offer_id=B returns a per-offer array (compare page).
    getGrandTotal({ commit }, params) {
        // offer_id may be a single id or an array (compare). Serialize arrays as repeated
        // offer_id=..&offer_id=.. (no [] brackets) to match the BE contract.
        return axios.get(`${process.env.VUE_APP_BIDEVAL}/grand_total`, {
            params,
            paramsSerializer(p) {
                const parts = [];
                Object.keys(p).forEach(k => {
                    const val = p[k];
                    if (val === undefined || val === null) return;
                    if (Array.isArray(val)) val.forEach(x => parts.push(`${k}=${encodeURIComponent(x)}`));
                    else parts.push(`${k}=${encodeURIComponent(val)}`);
                });
                return parts.join('&');
            },
        });
    },
    async getCollaborationData({commit}, param) {
        console.log(param);
        if (param.category_type != 'packages') {
            return await axios.get(`${process.env.VUE_APP_API_MSD}/quickaction?row_uuid=${param.row_uuid}&mr_id=${param.mr_id}&tag_id=${param.tag_id}&category=${param.category}`);
        } else {
            return await axios.get(`${process.env.VUE_APP_API_MSD}/quickaction?row_uuid=${param.row_uuid}&package_id=${param.package_id}&sub_package_id=${param.sub_package_uuid}&category=${param.category_type}`);
        }
    },
    uploadFile({commit}, item) {
        let data = new FormData();
        data.append('file', item.files)
        return axios.post(`${process.env.VUE_APP_API}/file/upload?${item.queryParam}`, data, {
            headers: {
                'Access-Control-Allow-Origin': '*'
            },
            processData: false,
            contentType: false,
        })
    },
    downloadFile({commit}, queryparams) {
        return axios.get(`${process.env.VUE_APP_API}/download/url?${queryparams}`);
    },
    downloadOffer({commit}, params) {
        return axios.get(`${process.env.VUE_APP_API}/offer/download?${params}`);
    },
    downloadAllFiles ({commit}, params) {
        return axios.post(`${process.env.VUE_APP_API_MSD}/tqthread/attachments/export`, params);
    },
    downloadMultipleFiles({commit}, queryParam) {
        return axios.get(`${process.env.VUE_APP_API}${queryParam}`);
    },
    async setOfferList ({commit}, { id, query }) {
        console.log('setOfferList => ', id, query);
        let list = ''
        if (query?.package_id) {
            list = await axios.get(`${process.env.VUE_APP_API_MSD}/tqthread/vendors?package_id=${id}`);    
        } else {
            list = await axios.get(`${process.env.VUE_APP_API_MSD}/tqthread/vendors?mr_id=${id}`);
        }
        commit('SET_OFFER_LSIT', list.data.data);
    },
    clearProjectDetails({commit}){
        commit('SET_PROJECT_DETAILS', {});
    },
    async setProjectDetails ({ commit }, payload) {
        let queryParams = ((payload.project_id)? `&project=${payload.project_id}`: '') + ((payload.mr_id)?`&item=${payload.mr_id}`: '')+ (payload.offer_id ? `&offer=${payload.offer_id}`: '') + (payload.package_id ? `&package_id=${payload.package_id}`: '')
        const projectDetails = await axios.get(`${process.env.VUE_APP_API}/header?page=${payload.page}${queryParams}`);
        commit('SET_PROJECT_DETAILS', projectDetails.data.data);
    },
    async getProjectUserList({commit}, projectId) {
        return await axios.get(`${process.env.VUE_APP_API}/project/manage?project=${projectId}`);
    },
    async getUserList({commit}, projectId) {
        return await axios.get(`${process.env.VUE_APP_API}/emails?project_id=${projectId}`);
    },
    notify({commit}, payload) {
        return axios.post(`${process.env.VUE_APP_API_MSD}/notify_users/internal`, payload);
    },
    getDocumentList({commit}, mrId) {
        if (mrId?.package_id) {
            return axios.get(`${process.env.VUE_APP_API}/mr/files?package_id=${mrId.package_id}&type=packages`);    
        } else {
            return axios.get(`${process.env.VUE_APP_API}/mr/files?id=${mrId}`);
        }
    },
    exportExtract({commit}, mrId) {
        return axios.get(`${process.env.VUE_APP_API_MSC}/lhs-extract-download?mr_id=${mrId}`)
    },
    exportTBE({commit}, mrId) {
        return axios.get(`${process.env.VUE_APP_API}/mr/timeline/export?mr_id=${mrId}`)
    },
    trackTBE({commit}, id) {
        return axios.get(`${process.env.VUE_APP_API_MSC}/job?job_id=${id}`)
    },
    async getVendorList() {
        return await axios.get(`${process.env.VUE_APP_API}/offer/vendors`);
    },
    async getCCEmails({commit}, projectId) {
        return await axios({
            url: process.env.VUE_APP_API + '/emails?project_id=' + projectId,
            method: 'get'
        });
    },
    async checkVendorName({commit}, payload) {
        return await axios({
            url: process.env.VUE_APP_API + '/offer/vendor_check?vendor_name=' + payload.venDel + '&check=vendor_name&item=' + payload.item_id,
            method: 'get'
        });
    },
    downloadTQAttachments({commit}, payload) {
        return axios.post(`${process.env.VUE_APP_API_MSD}/tqthread/attachments/export`, payload);
    },
    selectOtherContext ({ state }, param) {
        console.log('param => ', param);
        if (param?.category) {
            if (param.category == 'packages') {
                return axios.put(`${process.env.VUE_APP_API}/package/offer/multiple_context`, param)
            } else {
                return axios.put(`${process.env.VUE_APP_API}/offer/cycle`, param);
            }
        }
    },
    getCollaborationStats({commit}, payload) {
        return axios.post(`${process.env.VUE_APP_API_MSD}/collaboration/stats`, payload);
    },
    exportTimeline({commit}, payload) {
        if (payload.category == 'packages') {
            return axios.get(`${process.env.VUE_APP_API}/mr/timeline/export?package_id=${payload.package_id}&type=${payload.category}`)
        } else {
            return axios.get(`${process.env.VUE_APP_API}/mr/timeline/export?mr_id=${payload.mr_id}`)
        }
    },
    downloadJob({commit}, id) {
        return axios.get(`${process.env.VUE_APP_API_MSC}/job?job_id=${id}`)
    },
    downloadLHSExtract({commit}, payload) {
        if (payload.category == 'packages') {
            return axios.get(`${process.env.VUE_APP_API_MSC}/lhs-extract-download?package_id=${payload.package_id}`)
        } else {
            return axios.get(`${process.env.VUE_APP_API_MSC}/lhs-extract-download?mr_id=${payload.mr_id}`)
        }
    },
    updatePublishFlow({ state }, params) {
        return axios.put(`${process.env.VUE_APP_API}/set/publish-flow`, params);
    },
    lockTBE ({ state }, params) {
        return axios.post(`${process.env.VUE_APP_API_MSC}/tbe/lock`, params);
    },
    unLockTBE ({ state }, params) {
        return axios.post(`${process.env.VUE_APP_API_MSC}/tbe/unlock`, params);
    },
    getVendorListNames ({ state }, params) {
        return axios.get(`${process.env.VUE_APP_API}/offer/names?${params}`);
    },
    getValidateEmails ({ state }, params) {
        return axios.post(`${process.env.VUE_APP_API}/validate/emails`, params);
    },
    publishedVendorEmails ({ state }, params) {
        const baseUrl = `${process.env.VUE_APP_API}/current/emails?token=${params.token}&vendor_id=${params.vendor_id}&current_email=${params.current_email}`;
        const additionalParam = params.mr_id
            ? `&mr_id=${params.mr_id}`
            : `&package_id=${params.package_id}`;
        const finalUrl = `${baseUrl}${additionalParam}`;
        return axios.get(finalUrl);
    },
    async getRequisitionIds({ state }, projId){
        const [cbeRes, bidRes] = await Promise.all([
            axios.get(`${process.env.VUE_APP_API_CBE}/cbe/req/ids?project_id=${projId}`),
            axios.get(`${process.env.VUE_APP_API_BID}/project/requisitions?project_id=${projId}`)
        ]);
        const cbeData = cbeRes?.data?.data || [];
        const bidData = (bidRes?.data?.data || []).map(item => ({
            requisition_id: item.req_id,
            requisition_name: item.name,
            name: item.bid_tab_name,
            category: item.item_category,
            bid_type: item.bid_evaluation_type,
            item_type_id: item.item_type_id,
            item_type: item.item_type,
            tmr_id: item.tmr_id,
            pmr_id: item.pmr_id,
            source: 'bid'
        }));
        const bidDataMap = new Map(bidData.map(item => [item.requisition_id, item]));
        const merged = cbeData.map(item => {
            const bidItem = bidDataMap.get(item.requisition_id);
            if (bidItem) {
                return { ...item, pmr_id: bidItem.pmr_id || item.pmr_id };
            }
            return item;
        });
        const existingIds = new Set(cbeData.map(item => item.requisition_id));
        bidData.forEach(item => {
            if (!existingIds.has(item.requisition_id)) {
                merged.push(item);
            }
        });
        return { data: { data: merged } };
    },
    getApprovedRequisitions({ state }, { projectId, reqId }) {
        return axios.get(`${process.env.VUE_APP_API_BID}/bid/approved-requisitions?project_id=${projectId}&req_id=${reqId}`);
    },
    createCBE({ state }, params) {
        return axios.post(`${process.env.VUE_APP_API_CBE}/cbe/creation`, params);
    },
    getFlags() {
        return axios.get(`${process.env.VUE_APP_API}/flags`);
    },
    getInvitedReviewers({state}, ts_id) {
        return axios.get(`${process.env.VUE_APP_REQ}/user/reviewers?ts_id=${ts_id}`);
    },
    checkMappingProgress({state}, params) {
        return axios.get(`${process.env.VUE_APP_API_BID}/lhs/mapping-progress`, { params });
    }
}

const getters = {
    getDisciplines () {
        return state.disciplines;
    },
    getTagList () {
        return state.tags;
    },
    getOfferList() {
        return state.offerList;
    },
    getProjectDetails () {
        return state.projectDetails
    },
    getFeatureFlags() {
        return state.featureFlags
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}